import { Button, breakpoints } from '@gassan-ui'
import { MotionProps, motion } from 'framer-motion'
import { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled(motion.footer)`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  z-index: ${(p) => p.theme.zIndices.mobileFilters.confirmButton};
  padding-bottom: env(safe-area-inset-bottom);
  @media screen and (min-width: ${breakpoints.small}) {
    padding: 0.75rem 2rem;
  }
`

type Props = MotionProps & {
  onClickConfirm: () => void
}

function Footer({ onClickConfirm, children }: PropsWithChildren<Props>) {
  return (
    <Container initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <Button className="min-w-full" onClick={onClickConfirm} variant="dark">
        {children}
      </Button>
    </Container>
  )
}

export default Footer
